import { render, staticRenderFns } from "./PersonelList.vue?vue&type=template&id=4bd1ad13&scoped=true&"
import script from "./PersonelList.vue?vue&type=script&lang=ts&"
export * from "./PersonelList.vue?vue&type=script&lang=ts&"
import style0 from "./PersonelList.vue?vue&type=style&index=0&id=4bd1ad13&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd1ad13",
  null
  
)

export default component.exports